import { render, staticRenderFns } from "./order.vue?vue&type=template&id=4bd8a894&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=4bd8a894&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd8a894",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd8a894')) {
      api.createRecord('4bd8a894', component.options)
    } else {
      api.reload('4bd8a894', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=4bd8a894&scoped=true", function () {
      api.rerender('4bd8a894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingFunction/superSubsidyV2/order.vue"
export default component.exports